import i18n from "@/i18n";
import {URLS} from "@/constants";
import globalMethods from "@/globalMethods";
import {notify} from "@/plugins/notification";


const savedRole = globalMethods.getCookie("role");

export default {
    namespaced: true,
    state: {
        personalData: {},
        role: savedRole && savedRole !== "null" ? savedRole : null,
        personalStaffData: {},
    },
    mutations: {
        setRole(state, newRole) {
            state.role = newRole;
            if (newRole) {
                globalMethods.setCookie("role", newRole, 30 * 86400);
            } else {
                globalMethods.deleteCookie("role");
            }
        },
        setPersonalData(state, newPersonalData) {
            state.personalData = newPersonalData;
        },
        updatePersonalData(state, newName) {
            state.personalData.name = newName;
        },
        setPersonalStaffData(state, newPersonalStaffData) {
            state.personalStaffData = newPersonalStaffData;
        },
    },
    actions: {
        async setRole({commit}, role) {
            commit("setRole", role);
        },
        async getPersonalData({commit, state, rootState}) {
            const {company} = rootState;
            const url = URLS.MODEL.ACCOUNT.PERSONAL_DATA_URL;
            const headers = {role: state.role};
            if (company.companyData?.token) headers.companyId = company.companyData.token;
            const options = {
                method: "GET",
                headers,
                credentials: 'include',
            };
            const successfulHandler = (data) => {
                commit("setPersonalData", data.data);
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
        async updatePersonalData({commit, state, rootState}, newName) {
            const {company} = rootState;
            const url = URLS.MODEL.ACCOUNT.PERSONAL_DATA_URL;
            const options = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: state.role,
                    companyId: company.companyData?.token,
                },
                body: JSON.stringify({
                    name: newName,
                }),
                credentials: "include",
            };
            const successfulHandler = () => {
                notify(i18n.global.t("Profile information successfully updated"));
                commit("updatePersonalData", newName);
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
        async getPersonalStaffData({commit, state, rootState}) {
            const {company} = rootState;
            const url = URLS.MODEL.ACCOUNT.PERSONAL_STAFF_DATA_URL;
            const options = {
                method: "GET",
                headers: {
                    role: state.role,
                    companyId: company.companyData?.token,
                },
                credentials: "include"
            };
            const successfulHandler = (data) => {
                commit("setPersonalStaffData", data.data);
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
    },
};